module.exports = __webpack_public_path__ + "img/hero-home.3337e4cf.jpg";